var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"null"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-ic_NullData_"}})]),_c('div',[_vm._v(" 目前沒有相關資料哦~ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }